const HELVETICA_FONT_FAMILY = '"DS Indigo",DSIndigo,Helvetica,Arial,sans-serif'
const MAVEN_PRO_FONT_FAMILY = '"Maven Pro",Helvetica,Arial,sans-serif'

const tokens = {
  body: HELVETICA_FONT_FAMILY,
  heading: MAVEN_PRO_FONT_FAMILY,
} as const

export default tokens
